import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar la desconexión",
    opening: localizedGenderNode(
      [
      "Hoy no intento arreglarlo.",
      "Solo noto la desconexión tal como es.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento arreglarlo.",
      "Solo noto la desconexión tal como es.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo siento más la desconexión?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo siento más la desconexión?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar la desconexión ya es una conexión suave."
    ],
      [
      "Notar la desconexión ya es una conexión suave."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Qué falta allí",
    opening: localizedGenderNode(
      [
      "Hoy pregunto qué me falta en esta conexión.",
      "No para culpar.",
      "Solo identificar."
    ],
      [
      "Hoy pregunto qué me falta en esta conexión.",
      "No para culpar.",
      "Solo identificar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me falta de mi familia o de mis hijos?",
      "¿Qué me gustaría que vieran en mí?",
      "¿Qué me cuesta pedir?"
    ],
      [
      "¿Qué me falta de mi familia o de mis hijos?",
      "¿Qué me gustaría que vieran en mí?",
      "¿Qué me cuesta pedir?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una falta pequeña puede explicar mucho."
    ],
      [
      "Una falta pequeña puede explicar mucho."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre lo que falta.",
      "escribir una palabra sobre lo que falta."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Qué cambió entre nosotros",
    opening: localizedGenderNode(
      [
      "Hoy miro el cambio.",
      "Sin juicio.",
      "Solo ver."
    ],
      [
      "Hoy miro el cambio.",
      "Sin juicio.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué cambió recientemente?",
      "¿Qué había antes y falta ahora?",
      "¿Qué extraño?"
    ],
      [
      "¿Qué cambió recientemente?",
      "¿Qué había antes y falta ahora?",
      "¿Qué extraño?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La nostalgia es una señal de que hubo conexión."
    ],
      [
      "La nostalgia es una señal de que hubo conexión."
    ]
    ),
    action: localizedGenderNode(
      "recordar un buen momento.",
      "recordar un buen momento."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Lo que guardo dentro",
    opening: localizedGenderNode(
      [
      "Hoy observo lo que guardo dentro.",
      "No para soltar.",
      "Solo ver."
    ],
      [
      "Hoy observo lo que guardo dentro.",
      "No para soltar.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el abdomen."
    ],
      [
      "Respiro despacio.",
      "Siento el abdomen."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué no les digo?",
      "¿Por qué me quedo en silencio con eso?",
      "¿Qué temo que pase si lo digo?"
    ],
      [
      "¿Qué no les digo?",
      "¿Por qué me quedo en silencio con eso?",
      "¿Qué temo que pase si lo digo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El silencio a veces protege."
    ],
      [
      "El silencio a veces protege."
    ]
    ),
    action: localizedGenderNode(
      "escribir una frase que no dije.",
      "escribir una frase que no dije."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El miedo bajo la desconexión",
    opening: localizedGenderNode(
      [
      "Hoy pregunto qué me asusta de la cercanía.",
      "No para pelear.",
      "Solo saber."
    ],
      [
      "Hoy pregunto qué me asusta de la cercanía.",
      "No para pelear.",
      "Solo saber."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué temo que pase si me acerco?",
      "¿Qué intento proteger?",
      "¿Cómo me protege este miedo?"
    ],
      [
      "¿Qué temo que pase si me acerco?",
      "¿Qué intento proteger?",
      "¿Cómo me protege este miedo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El miedo también es una señal de querer conexión."
    ],
      [
      "El miedo también es una señal de querer conexión."
    ]
    ),
    action: localizedGenderNode(
      "decirme \"Te veo\".",
      "decirme \"Te veo\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Un pequeño momento de conexión",
    opening: localizedGenderNode(
      [
      "Hoy busco un pequeño momento de conexión.",
      "No grande.",
      "Pequeño es suficiente."
    ],
      [
      "Hoy busco un pequeño momento de conexión.",
      "No grande.",
      "Pequeño es suficiente."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo hubo un pequeño momento de conexión?",
      "¿Qué lo permitió?",
      "¿Cómo puedo invitar otro momento así?"
    ],
      [
      "¿Cuándo hubo un pequeño momento de conexión?",
      "¿Qué lo permitió?",
      "¿Cómo puedo invitar otro momento así?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento pequeño cambia la sensación."
    ],
      [
      "Un momento pequeño cambia la sensación."
    ]
    ),
    action: localizedGenderNode(
      "recordar un momento así.",
      "recordar un momento así."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Quedarme un momento más",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme un momento más en la conexión.",
      "No huir tan rápido.",
      "Solo un momento."
    ],
      [
      "Hoy practico quedarme un momento más en la conexión.",
      "No huir tan rápido.",
      "Solo un momento."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me retiro demasiado rápido?",
      "¿Qué me asusta si me quedo?",
      "¿Qué pasa si me quedo 10 segundos más?"
    ],
      [
      "¿Cuándo me retiro demasiado rápido?",
      "¿Qué me asusta si me quedo?",
      "¿Qué pasa si me quedo 10 segundos más?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un momento más puede cambiar algo."
    ],
      [
      "Un momento más puede cambiar algo."
    ]
    ),
    action: localizedGenderNode(
      "pausar 10 segundos antes de retirarme.",
      "pausar 10 segundos antes de retirarme."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una palabra suave",
    opening: localizedGenderNode(
      [
      "Hoy observo una palabra suave que puedo traer.",
      "No mucho.",
      "Una palabra."
    ],
      [
      "Hoy observo una palabra suave que puedo traer.",
      "No mucho.",
      "Una palabra."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué palabra suave me gustaría decir?",
      "¿A quién me gustaría decirla?",
      "¿Cómo se siente decirla?"
    ],
      [
      "¿Qué palabra suave me gustaría decir?",
      "¿A quién me gustaría decirla?",
      "¿Cómo se siente decirla?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una palabra puede abrir un corazón."
    ],
      [
      "Una palabra puede abrir un corazón."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra suave.",
      "escribir una palabra suave."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Una petición",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición pequeña.",
      "No una exigencia.",
      "Una petición."
    ],
      [
      "Hoy formulo una petición pequeña.",
      "No una exigencia.",
      "Una petición."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me gustaría pedir con suavidad?",
      "¿Cómo puedo decirlo con dulzura?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué me gustaría pedir con suavidad?",
      "¿Cómo puedo decirlo con dulzura?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede cambiar el ritmo."
    ],
      [
      "Una petición puede cambiar el ritmo."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Ver el otro lado",
    opening: localizedGenderNode(
      [
      "Hoy intento ver también el otro lado.",
      "No para justificar.",
      "Solo ver."
    ],
      [
      "Hoy intento ver también el otro lado.",
      "No para justificar.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Estoy aquí."
    ],
      [
      "Respiro despacio.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué podría ser difícil también para ellos?",
      "¿Qué podrían temer perder?",
      "¿Qué cambia en mí cuando veo eso?"
    ],
      [
      "¿Qué podría ser difícil también para ellos?",
      "¿Qué podrían temer perder?",
      "¿Qué cambia en mí cuando veo eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una mirada más amplia puede suavizar el dolor."
    ],
      [
      "Una mirada más amplia puede suavizar el dolor."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra de suavidad hacia ellos.",
      "escribir una palabra de suavidad hacia ellos."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "El valor que nos sostiene",
    opening: localizedGenderNode(
      [
      "Hoy busco un valor que sostenga la conexión.",
      "Pequeño.",
      "Pero verdadero."
    ],
      [
      "Hoy busco un valor que sostenga la conexión.",
      "Pequeño.",
      "Pero verdadero."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor me importa en la familia?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ],
      [
      "¿Qué valor me importa en la familia?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor puede ser un hilo de conexión."
    ],
      [
      "Un valor puede ser un hilo de conexión."
    ]
    ),
    action: localizedGenderNode(
      "una palabra que exprese ese valor.",
      "una palabra que exprese ese valor."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Volver a mí dentro del vínculo",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo volver a mí dentro de la familia.",
      "No para huir.",
      "Solo volver."
    ],
      [
      "Hoy observo cómo volver a mí dentro de la familia.",
      "No para huir.",
      "Solo volver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento mis pies."
    ],
      [
      "Respiro despacio.",
      "Siento mis pies."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me devuelve a mí en este vínculo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ],
      [
      "¿Qué me devuelve a mí en este vínculo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Volver a mí también es conexión."
    ],
      [
      "Volver a mí también es conexión."
    ]
    ),
    action: localizedGenderNode(
      "una respiración cuando estoy con la familia.",
      "una respiración cuando estoy con la familia."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño de cercanía",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de cercanía.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de cercanía.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para moverme."
    ],
      [
      "Un paso pequeño es suficiente para moverme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve a la cercanía.",
      "Cuando me siento lejos.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve a la cercanía.",
      "Cuando me siento lejos.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta desconexión?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre esta desconexión?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo sentirme lejos y aun así quedarme conmigo."
    ],
      [
      "Puedo sentirme lejos y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const feelingDisconnectedFromTheFamilyChildrenBlueprintEs = buildNormalizedPilotBlueprint({
  id: "feeling_disconnected_from_the_family_children_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "feeling_disconnected_from_the_family_children",
  category: "loneliness_belonging",
  journeyName: {
    he: "תחושת נתק מהמשפחה / מהילדים",
    en: "Feeling disconnected from the family / children",
    es: "Sensación de desconexión de la familia / de los hijos",
  },
  days,
});

export default feelingDisconnectedFromTheFamilyChildrenBlueprintEs;
